import { useContext } from "react"
import FormButtonWrapper from "../components/Form/Buttons/FormButtonMapper"
import ModalFormContext from "../store/ModalFormContext"

import filterData from "../functions/filterData"
import { AppSettingsVar } from "../_project/settings"
  
const useButtonActions = () => {
    const context = useContext(ModalFormContext)
    const getButtonActions = (object_id = null, filter = {}, className="mx-1 btn btn-sm 0"+AppSettingsVar.button_class, button_name=null, icon=false, formData = null, callbackFunc = null, alter_url_func = null, disabled=false, action_type=null, finalizeTag) => {
        // const copy_actions = [...context.forms] //making copy in order not to alter all actions
        const copy_actions = JSON.parse(JSON.stringify(context.forms)) //making copy in order not to alter all actions
        if('app_name' in filter){
            filter['include_in_portal'] = true
        }
        var return_actions = []
        if(filter.action_id){
            if(Array.isArray(filter.action_id)){
                return_actions = copy_actions.filter( e => filter.action_id.includes(e.action_id))
            }
            else{
                return_actions = copy_actions.filter( e => e.action_id == filter.action_id)
            }
        }
        else{
            return_actions = filterData(copy_actions, filter)
        }
        return return_actions.map( e => {
            var url = e.form_url.replace('<pk>', object_id) ;
            if(button_name !== null ) e.action_name = button_name
            return <FormButtonWrapper 
                    key={e.action_id} 
                    id={object_id} 
                    action_type={action_type} 
                    title={button_name} 
                    disabled={disabled} 
                    icon={icon} 
                    element={e} 
                    formData={formData} 
                    url={url} 
                    className={className} 
                    callbackFunc={callbackFunc} 
                    alter_url_func={alter_url_func} 
                    finalizeTag={finalizeTag} >  
            </FormButtonWrapper>
        })
    }
    return getButtonActions
}

export default useButtonActions